<template>
    <card>
        <aspect-ratio-box :ratio="16/9">
            <skeleton height="100%" width="100%"/>
        </aspect-ratio-box>

        <card-title large>
            <skeleton height="25" class="mb-8" :width="80" rounded/>
        </card-title>
        <card-subtitle x-small>
            <skeleton width="160" class="mb-10" height="12" rounded/>
        </card-subtitle>
        <card-text class="text-truncate">
            <paragraph-skeleton :lines="3" small/>
        </card-text>

        <card-subtitle>
            <chip-skeleton width="120" small/>
        </card-subtitle>
    </card>
</template>

<script>
export default {
    name: 'ArticleCardSkeleton',

}
</script>

